import { useEffect, useRef, useState } from 'react'
import { useSliceStateSelector } from 'slices/hooks'
import { LanguageState } from 'slices/Language/slice'

//key name for session storage
export const LANGUAGE_DISCLAIMER_KEY = 'trrHasSeenLanguageDisclaimer'
export const useLanguageDisclaimer = () => {
  const [open, setOpen] = useState(false)
  const isFirstRender = useRef(true)
  const previousLanguage = useRef<LanguageState>('sv')

  const { selectedLanguage } = useSliceStateSelector(
    (state) => state.slices.language
  )

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      previousLanguage.current = selectedLanguage
      return
    }

    const hasSeenDisclaimer =
      sessionStorage.getItem(LANGUAGE_DISCLAIMER_KEY) === 'true'
    const isChangingToEnglish =
      selectedLanguage === 'en' && previousLanguage.current !== 'en'

    if (isChangingToEnglish && !hasSeenDisclaimer) {
      setOpen(true)
    }

    previousLanguage.current = selectedLanguage
  }, [selectedLanguage])

  const handleClose = () => {
    sessionStorage.setItem(LANGUAGE_DISCLAIMER_KEY, 'true')
    setOpen(false)
  }

  return { open, handleClose }
}
